import { AsmEngagementsViewId } from '../models/asm-engagements-view-id';
import { AsmEngagementsType } from '../models/asm-engagements-type';
import { SolType, SolViewId, TypeService, ViewService } from '@sol/components';
import { AsmKeywordSelectOptions } from '@asm/components-core/components/view/asm-view-edit-keyword-select/asm-view-edit-keyword-select.component';
import {
  ENGAGEMENT_REQUEST_STATUS_CONFIG,
  EngagementRequestStatus,
  SUBSCRIPTION_TYPE_CONFIG,
} from '../models/engagement-request';
import { AsmEngagementRequestTagTools } from '../tools/asm-engagement-request-tag.tools';

export function provideAsmEngagementsViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmEngagementsType.credentialKeyValue);
  typeService.addType(AsmEngagementsType.credentialKeyValueEdit);
  typeService.addType(AsmEngagementsType.engagementId);
  typeService.addType(AsmEngagementsType.engagementStatus);
  typeService.addType(AsmEngagementsType.subscriptionType);
  viewService.addView(
    AsmEngagementsType.credentialKeyValue,
    'edit',
    AsmEngagementsViewId.credentialKeyValue,
    () =>
      import('../components/view/asm-view-edit-credential-key-value/asm-view-edit-credential-key-value.component').then(
        m => m.AsmViewEditCredentialKeyValueComponent,
      ),
    true,
  );
  viewService.addView(
    AsmEngagementsType.credentialKeyValueEdit,
    'edit',
    AsmEngagementsViewId.credentialKeyValue,
    () =>
      import('../components/view/asm-view-edit-credential-key-value/asm-view-edit-credential-key-value.component').then(
        m => m.AsmViewEditCredentialKeyValueComponent,
      ),
    true,
  );
  viewService.addView(
    AsmEngagementsType.engagementId,
    'edit',
    AsmEngagementsViewId.engagementIdEdit,
    () =>
      import('../components/view/asm-view-edit-engagement-id/asm-view-edit-engagement-id.component').then(
        m => m.AsmViewEditEngagementIdComponent,
      ),
    true,
  );
  viewService.addView(
    AsmEngagementsType.engagementId.array,
    'edit',
    AsmEngagementsViewId.engagementIdEdit,
    () =>
      import('../components/view/asm-view-edit-engagement-id/asm-view-edit-engagement-id.component').then(
        m => m.AsmViewEditEngagementIdComponent,
      ),
    true,
  );
  viewService.deriveView(SolType.string.array, 'read', AsmEngagementsType.engagementId, SolViewId.textField, {
    isDefault: true,
    mapValue: (id: string) => [id],
  });
  const statusLabels = Object.fromEntries(
    Object.entries(ENGAGEMENT_REQUEST_STATUS_CONFIG).map(([id, cfg]) => [id, cfg.label]),
  );
  const subscriptionLabels = Object.fromEntries(
    Object.entries(SUBSCRIPTION_TYPE_CONFIG).map(([id, cfg]) => [id, cfg.label]),
  );
  viewService.addView(
    AsmEngagementsType.engagementStatus,
    'edit',
    SolViewId.of<AsmKeywordSelectOptions>('engagementStatusEdit', { labels: statusLabels }),
    () =>
      import('@asm/components-core/components/view/asm-view-edit-keyword-select/asm-view-edit-keyword-select.component').then(
        m => m.AsmViewEditKeywordSelectComponent,
      ),
    true,
  );
  viewService.addView(
    AsmEngagementsType.engagementStatus.array,
    'edit',
    SolViewId.of<AsmKeywordSelectOptions>('engagementStatusEdit', { labels: statusLabels }),
    () =>
      import('@asm/components-core/components/view/asm-view-edit-keyword-select/asm-view-edit-keyword-select.component').then(
        m => m.AsmViewEditKeywordSelectComponent,
      ),
    true,
  );
  viewService.addView(
    AsmEngagementsType.subscriptionType,
    'edit',
    SolViewId.of<AsmKeywordSelectOptions>('subscriptionTypeEdit', { labels: subscriptionLabels }),
    () =>
      import('@asm/components-core/components/view/asm-view-edit-keyword-select/asm-view-edit-keyword-select.component').then(
        m => m.AsmViewEditKeywordSelectComponent,
      ),
    true,
  );
  viewService.addView(
    AsmEngagementsType.subscriptionType.array,
    'edit',
    SolViewId.of<AsmKeywordSelectOptions>('subscriptionTypeEdit', { labels: subscriptionLabels }),
    () =>
      import('@asm/components-core/components/view/asm-view-edit-keyword-select/asm-view-edit-keyword-select.component').then(
        m => m.AsmViewEditKeywordSelectComponent,
      ),
    true,
  );
  viewService.deriveView(SolType.tag.array, 'read', AsmEngagementsType.engagementStatus, SolViewId.tag, {
    isDefault: true,
    mapValue: (status: string) => [AsmEngagementRequestTagTools.toStatusTag(status as EngagementRequestStatus)],
  });
  viewService.deriveView(SolType.tag.array, 'read', AsmEngagementsType.subscriptionType, SolViewId.tag, {
    isDefault: true,
    mapValue: (subscription: string) => [AsmEngagementRequestTagTools.toSubscriptionTag(subscription)],
  });
}
